<div class="teacher-dashboard-block"
     [ngClass]="[hasFooter ? 'has-footer' : '', 'theme--' + theme]">
  <div class="teacher-dashboard-block__headline">
    <brt-dashboard-boxes-head [data]="headlineData"></brt-dashboard-boxes-head>
  </div>

  <div class="teacher-dashboard-block__content">
    <div class="teacher-dashboard-block__empty" *ngIf="emptyData && !hasProjectedContent">
      <div class="teacher-dashboard-block__empty-image" [ngStyle]="{'backgroundImage': 'url(\'' + emptyData.imageSrc + '\')'}">
      </div>

      <div class="teacher-dashboard-block__empty-content">
        <div class="teacher-dashboard-block__empty-title">
          {{emptyData.title}}
        </div>

        <div class="teacher-dashboard-block__empty-description">
          {{emptyData.description}}
        </div>
      </div>
    </div>

    <div class="teacher-dashboard-block__projected-content" [ngClass]="{'own-template': useOwnTemplate}" #projectedContent>
      <ng-content></ng-content>
    </div>
  </div>

  <div class="teacher-dashboard-block__action-button" >
    <div class="teacher-dashboard-block__action-button-wrapper">
      <brt-button
        *ngIf="actionButtonLabel && hasProjectedContent"
        [title]="actionButtonLabel" [color]="'river'" [size]="'small'" (click)="onActionButtonClicked.emit()"></brt-button>

      <brt-button
        *ngIf="emptyData && !hasProjectedContent && emptyData.buttonCallback && emptyData.buttonLabel"
        [title]="emptyData.buttonLabel" [color]="'river'" [size]="'small'" (click)="emptyData.buttonCallback()"></brt-button>

    </div>
  </div>
</div>
